import * as React from 'react';
import { SVGProps } from 'react';
const SvgPrint = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.88974 11.9998C6.56472 11.9998 7.1119 11.4526 7.1119 10.7776C7.1119 10.1026 6.56472 9.55544 5.88974 9.55544C5.21476 9.55544 4.66757 10.1026 4.66757 10.7776C4.66757 11.4526 5.21476 11.9998 5.88974 11.9998Z"
      fill="current"
    />
    <path
      d="M23 5.99546H19.311V2.22266H4.69014V5.99546H1L1.00109 18.1108L4.69014 18.1106L4.66757 16H2.97744L3 8H21V16H19.3335L19.311 18.1106H23V5.99546ZM17.6187 5.99546H6.38236V3.9532H17.6187V5.99546Z"
      fill="current"
    />
    <path
      d="M19.3335 13.2213L4.66757 13.2221V21.7771H19.3335V13.2213ZM17.6361 20.1824H6.36502V14.8165H17.6361V20.1824ZM8.3765 18.3008H15.6246C15.6246 18.3008 15.6246 16.9176 15.6246 16.7062H8.3765C8.3765 16.9176 8.3765 18.3008 8.3765 18.3008Z"
      fill="current"
    />
  </svg>
);
export default SvgPrint;
